import axios from "axios"

export const HeaderAPI={
    login:function(data){
       return axios({
            method:"POST",
            url:`${process.env.REACT_APP_API_URL}/user/login`,
            data:data
        })
    }
}


    